@if (!loading) {
<div>
	<div class="margin-top">
		@if (dashboardData != null) {
		<app-data-tile-list [title]="dashboardData.HealthStats.Total + ' Devices'" titleColor="primary"
			statusColor="medium" [dataTiles]="tileListRow1">
		</app-data-tile-list>
		}
	</div>
	<div class="row2">
		@if (dashboardData != null) {
		<app-data-tile-list [dataTiles]="tileListRow2">
		</app-data-tile-list>
		}
		@if (dashboardData != null) {
		<app-data-tile-list title="Device Activity Breakdown" titleColor="primary" [segementedTiles]="tileListRow3"
			[segmentedTile]="true">
		</app-data-tile-list>
		}
		@if (dashboardData != null) {
		<app-data-tile-list [dataTiles]="tileListRow4">
		</app-data-tile-list>
		}
	</div>
	@if (dashboardData != null && devicesOverTimeData != null) {
	<div>
		<app-data-device-over-time-chart [data]="devicesOverTimeData" (timeFrame)="timeFrameChange($event)"
			[defaultTimeFrame]="timeFrameMonths" (monthlyToggleChanged)="monthlyToggleChanged()"
			(dailyToggleChanged)="dailyToggleChanged()" [monthlyToggle]="monthlyToggleValue"
			[dailyToggle]="dailyToggleValue" [isKeepAlive]="true">
		</app-data-device-over-time-chart>
	</div>
	}
</div>
}
@if (loading) {
<div class="loader">
	<mat-spinner></mat-spinner>
</div>
}